import * as React from 'react';

export function SvgGoogleDocs(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_171)">
        <path
          d="M18.6875 22H5.3125C4.59062 22 4 21.3864 4 20.6364V3.36364C4 2.61364 4.59062 2 5.3125 2H15.1875L20 7V20.6364C20 21.3864 19.4094 22 18.6875 22Z"
          fill="#3086F6"
        />
        <path d="M15.1874 2L19.9999 7H15.1874V2Z" fill="#0C67D6" />
        <path
          d="M15.9375 10.8636H8.0625V9.72726H15.9375V10.8636ZM15.9375 12.4545H8.0625V13.5909H15.9375V12.4545ZM13.75 15.1818H8.0625V16.3182H13.75V15.1818Z"
          fill="#FDFFFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_171">
          <rect
            width="16"
            height="20"
            fill="white"
            transform="translate(4 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
